interface ReactMethods {
  moveSelectionUp: CallableFunction;
  moveSelectionDown: CallableFunction;
  setResults: CallableFunction;
  getAttendees: CallableFunction;
  // eslint-disable-next-line no-unused-vars
  setShow: (value: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  setPos: (x: number, y: number) => void;
  getSelectedMention: () => string;
}

class MentionsAdapter {
  public moveSelectionUp: CallableFunction = () => null;

  public moveSelectionDown: CallableFunction = () => null;

  public setShow: CallableFunction = () => null;

  public setPos: CallableFunction = () => null;

  public getSelectedMention: CallableFunction = () => null;

  public setResults: CallableFunction = () => null;

  public getAttendees: CallableFunction = () => [];

  set reactMethods({
    moveSelectionUp,
    moveSelectionDown,
    setResults,
    setShow,
    setPos,
    getSelectedMention,
    getAttendees,
  }: ReactMethods) {
    this.setResults = setResults;
    this.moveSelectionUp = moveSelectionUp;
    this.moveSelectionDown = moveSelectionDown;
    this.setShow = setShow;
    this.setPos = setPos;
    this.getSelectedMention = getSelectedMention;
    this.getAttendees = getAttendees;
  }
}

export default new MentionsAdapter();
